import axios from "axios";

/**
 * Base URL for authentication server without trailing slash
 */
const BASE_SERVER = "https://www.saliorel.cloud";

const Timetable = {
  /**
   * Returns timetable
   */
  fetch: (request, callback) =>
    axios
      .get(`${BASE_SERVER}/inc/timetable/timetable_frustrating`, {
        params: {
          date: request.apiFormattedDate(),
          class: request.timetableIdentifier
        }
      })
      .then(response => callback(response.data))
};

/**
 * TimetableRequest
 *
 * (c) Stefan Wittwer 2018 | Alle Rechte vorbehalten.
 *
 * Embodies a timetable request and holding all neccessary
 * request information.
 */
export class TimetableRequest {
  constructor(type, identifier) {
    this.timetableType = type;
    this.timetableIdentifier = identifier;

    this.timetableDate = new Date();
  }

  /**
   * Sets the week offset for the timetable request.
   * @param {Int} shift Number of weeks shifted from current week
   */
  setWeek(shift) {
    const date = new Date();

    const weekdaysUntilMonday = (1 + 7 - date.getDay()) % 7;
    const numberOfDays = (shift - 1) * 7;

    date.setDate(date.getDate() + weekdaysUntilMonday + numberOfDays);

    this.timetableDate = date;
    return date;
  }

  /**
   * Returns the date for the requested timetable in the API-format
   */
  apiFormattedDate() {
    const date = this.timetableDate;
    return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
  }

  /**
   * Attempts to fetch this timetable request with a callback.
   * @param {Function} callback
   */
  fetch(callback) {
    Timetable.fetch(this, callback);
  }
}

export const TimetableType = {
  CLASS: "CLASS"
};

export default Timetable;



// WEBPACK FOOTER //
// ./src/api/Timetable.js